export const htmlEdit = (html) => {
  const $html = $(html);

  const $img = $html.children("img");
  $img.attr("src", `${$img.attr("src")}?1`);

  return $html;
};
